import gql from 'graphql-tag'

export default gql`query report_project_invoicing{
  report_project_invoicing{
    project_id
    
    name
    project_status_id
    project_status{
        description
    }
    project_clients{
      client{
        client_id
        name
      }
    }
    project_client_budgets{
      project_activity_budget_id
      client_id
      project_id
      project_activity_type_id
      project_activity_type{
        description
      }
      description
      stage
      amount_to_invoice
      budget_label
    }
    total_budget
    total_fees
    total_invoiced
    total_credit_notes
    total_supplier_invoiced
    total_writeoff
    amount_to_invoice
  }
  project_client_invoices{
    id
    invoice_number
    project{
      project_id
      name
      clients{
        client_id
        name
      }
      
    }
    client{
      client_id
      name
    }
    issued_at
    paid_at
    created_at
    invoice_url
    breakdown{
      id
      description
      amount
    }
    credit_notes{
      id
      invoice_number
      invoice_url
      created_at
      breakdown{
        id
        description
        amount
      }
    }
  }
}`